const COLUMNAS_EXCEL = [
    {
        value: 0,
        label: "CODE",
        descripcion:
            "",
        verMas: false,
        obligatorio: false,
    },
    {
        value: 1,
        label: "NAME",
        descripcion:
            "",
        verMas: false,
        obligatorio: true,
    },
    {
        value: 2,
        label: "NOTE",
        descripcion:
            "",
        verMas: false,
        obligatorio: false,
    },
];

const INDEX_COLUMNAS_EXCEL = {
    CODE: 0,
    NAME: 1,
    NOTE: 2,
};

const COLUMNAS_EXCEL_STRING = {
    CODE: "CODE",
    NAME: "NAME",
    NOTE: "NOTE",
};

export {
    COLUMNAS_EXCEL,
    INDEX_COLUMNAS_EXCEL,
    COLUMNAS_EXCEL_STRING,
}